import cx from 'classnames';
import { isEqual, startOfDay } from 'date-fns';
import { DayContent, DayContentProps } from 'react-day-picker';

import { defaultHoverTransition } from '../../../utils/utils';

const DayContentWrapper = ({ date, ...rest }: DayContentProps) => {
  const isCurrentDay = isEqual(date, startOfDay(new Date()));
  const currentDayClassName = isCurrentDay ? 'border border-primary-50' : '';

  return (
    <div
      className={cx(
        'flex h-10 w-10 items-center justify-center rounded-xl',
        currentDayClassName,
        defaultHoverTransition
      )}
    >
      <DayContent date={date} {...rest} />
    </div>
  );
};

export default DayContentWrapper;
